<template>
  <div>
    <a-row>
      <g-master name="Seguimientos"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :parentData="parentData"
                modalWidth="100%"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Resultado del indicador(%)')">
                <a-input style="width: 100%"
                         v-decorator="['indicator_result', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Descripción del resultado')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_result_description', { rules: [{ required: false }] }]"
                          :params="eva_descripcion">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Seguimiento - Descripción Cualitativa')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_qualitative_description_monitoring', { rules: [{ required: false }] }]"
                          :params="eva_descripcion_cualitativa">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Seguimiento - Comentario')">
                <a-textarea autoSize
                            v-decorator="['comment_monitoring', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['id_objective'],
    data () {
      return {
        eva_descripcion: {
          h_lookup_type: 'EVA_DESCRIPCION_RESULTADO'
        },
        eva_descripcion_cualitativa: {
          h_lookup_type: 'EVA_DESCRIPCION_CUALITATIVA_SEGUIMIENTO'
        },
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'eva_seguimiento',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Resultado del indicador (%)', dataIndex: 'indicator_result', align: 'center', sorter: true, width: 250},
              {title: 'Descripcion del resultado', dataIndex: 'desc_result_description', align: 'center', sorter: true},
              {
                title: 'Seguimiento',
                align: 'center',
                children: [
                  {
                    title: 'Descripcion cualitativa',
                    dataIndex: 'desc_qualitative_description_monitoring',
                    align: 'center',
                    sorter: true
                  },
                  {title: 'Comentario', dataIndex: 'comment_monitoring', align: 'center', sorter: true}
                ]
              }
            ]
          },
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_objective: this.id_objective
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/Seguimientos.vue